var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCompany = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "business-and-finance copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 23.966C0 10.7299 10.7299 0 23.966 0C37.1955 0.0156073 47.9163 10.7364 47.9319 23.966C47.9319 37.202 37.202 47.9319 23.966 47.9319C10.7299 47.9319 0 37.202 0 23.966ZM36.8422 21.7872H43.4459C42.4171 12.6922 35.2397 5.51485 26.1447 4.48599V11.0897C31.6187 12.0253 35.9067 16.3132 36.8422 21.7872ZM23.966 32.6809C19.1529 32.6809 15.2511 28.7791 15.2511 23.966C15.2511 19.1529 19.1529 15.2511 23.966 15.2511C28.7791 15.2511 32.6809 19.1529 32.6809 23.966C32.6809 26.2773 31.7627 28.494 30.1283 30.1283C28.494 31.7627 26.2773 32.6809 23.966 32.6809ZM21.7872 11.0897V4.48599C12.6922 5.51485 5.51485 12.6922 4.48599 21.7872H11.0897C12.0253 16.3132 16.3132 12.0253 21.7872 11.0897ZM4.48599 26.1447H11.0897C12.0253 31.6187 16.3132 35.9067 21.7872 36.8422V43.4459C12.6922 42.4171 5.51485 35.2397 4.48599 26.1447ZM26.1447 36.8422V43.4459C35.2397 42.4171 42.4171 35.2397 43.4459 26.1447H36.8422C35.9067 31.6187 31.6187 35.9067 26.1447 36.8422Z",
    fill: "#4A4A4A"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCompany);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/company.6087ff03f71ea1b267cc5d6f1e390180.svg";